import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import type { FocusEvent } from "react";
import { twMerge } from "tailwind-merge";

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

function selectAllText(event: FocusEvent<HTMLInputElement, Element>) {
  event.target.select();
}

export { cn, selectAllText };
